const KEY_MAX = 64;
const ORDINAL = /^([a-z0-9]*[a-z])(\d{1,3})$/;
/**
 * The key of a header: Unicode NFKC, lower case, and only `a-z` and `0-9` kept. `Event City`,
 * `event_city` and `EventCity` all give `eventcity`. A header with no Latin letter or digit (a blank
 * header, or one in another script) gives an empty key and is never suggested. A key is cut at 64
 * characters (the width of the `import_field_aliases.alias_key` column).
 */
export function aliasKeyOf(header) {
    return header
        .normalize("NFKC")
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "")
        .slice(0, KEY_MAX);
}
/**
 * The key of a header and its trailing ordinal. A header that ends in one to three digits after a
 * letter is split: `Celebrity3` is key `celebrity` and ordinal 3. Any other header keeps its whole key
 * and has no ordinal. The ordinal is used only for a field that takes several columns.
 */
export function headerKey(header) {
    const key = aliasKeyOf(header);
    const match = ORDINAL.exec(key);
    if (match === null)
        return Object.freeze({ key, ordinal: null });
    return Object.freeze({ key: match[1] ?? key, ordinal: Number(match[2]) });
}
/** The key to store when staff ask to remember a header, or `null` when the header has no usable key. */
export function learnableAliasKey(header) {
    const key = aliasKeyOf(header);
    return key === "" ? null : key;
}
